// @flow
import React, { Component, Fragment } from 'react';
import { withHelmet } from 'infrastructure/seo/Helmet';
import type { BlocContent } from 'types/NewsletterBloc';
import type { RencontreType } from 'types/Rencontre';
import type { Status } from 'types/Status';
import type { FullUserType } from 'types/User';

import { STATUS_LOADING, STATUS_SUCCESS } from 'constants/statusConstants';
import Loading from 'components/fragments/Loading';
import Breadcrumb from 'components/fragments/Breadcrumb';
import Sidebar from 'components/sidebar/Sidebar';
import FooterSocial from 'components/footer/FooterSocial';

import SubMenuHeader from 'components/header/SubMenuHeader';
import TeamComposition from 'components/rencontre/TeamComposition';
import LastRencontresSection from 'components/rencontre/LastRencontresSection';
import OpponentTeamComposition from 'components/rencontre/OpponentTeamComposition';
import MatchStats from 'components/rencontre/MatchStats';
import Highlights from 'components/rencontre/Highlights';
import { reorderDateFormat } from 'utils/rencontreUtils';
import BannerScoreboard from 'components/rencontre/BannerScoreboard';
import { handleTagEvent } from 'utils/tagManagerUtils';

export type StateProps = {
  id_rencontre: number,
  title: string,
  description: Array<BlocContent>,
  rencontre_background: string,
  featured_media: {
    src: string,
    legend: string
  },
  sidebar_content: Array<BlocContent>,
  rencontreData: RencontreType,
  rencontreFetchStatus: Status,
  meta_title: string,
  status: Status,
  alertesBilletterie: Array<number>,
  identifie: boolean,
  userPref: FullUserType
};

export type DispatchProps = {
  fetchPageList: (slug: string) => void,
  fetchRencontre: (slug: string) => void,
  postUserPref: (action: string, value: any, token: string) => void,
  displayModal: (modalObject: string, content?: Object) => void
};

export type Props = {
  match: {
    params: {
      slug: string,
      typeRugby: string,
      competition: string,
      rencontre: string,
      tab: string
    }
  }
} & DispatchProps &
  StateProps;

class Rencontre extends Component<Props> {
  static getDerivedStateFromProps(props: Props) {
    const {
      rencontreData: { id },
      alertesBilletterie,
      identifie,
      postUserPref,
      displayModal
    } = props;
    const localAlert = localStorage.getItem('alertLocal');

    if (
      identifie &&
      id === parseInt(localAlert, 10) &&
      localAlert &&
      localAlert !== '' &&
      !alertesBilletterie.includes(parseInt(localAlert, 10))
    ) {
      postUserPref('billetterie-alerte-add', `${localAlert}`, props.userPref.token);
      localStorage.setItem('alertLocal', '');
      displayModal('MODAL_UNSUBSCRIBE_NEWSLETTER_DONE');
    }

    return null;
  }

  componentDidMount() {
    const {
      fetchRencontre,
      fetchPageList,
      match: {
        params: { rencontre, slug }
      }
    } = this.props;

    fetchRencontre(rencontre);
    fetchPageList(slug);
  }

  renderTicketingAlert = () => {
    const {
      identifie,
      alertesBilletterie,
      //userPref,
      displayModal,
      //postUserPref,
      rencontreData: {
        id,
        title: { raw: title }
      }
    } = this.props;

    if (identifie) {
      if (alertesBilletterie.includes(id)) {
        return (
          <a
            tabIndex="0"
            onClick={() => displayModal('MODAL_TICKETING_REMOVE_SUCCESS', { id, title })}
            role="button"
            className="btn banner__button btn--white"
          >
            <i className="icon icon-delete is-inline"></i>
            <span>Supprimer mon alerte</span>
          </a>
        );
      } else {
        return null;
        /*
        return (
          <a
            role="button"
            tabIndex='0'
            onClick={() => {
              postUserPref('billetterie-alerte-add', `${id}`, this.props.userPref.token);
              handleTagEvent(
                'billet_match',
                'alerte_billet',
                title,
                userPref
              )();
              displayModal('MODAL_UNSUBSCRIBE_NEWSLETTER_DONE');
            }}
            className="btn banner__button btn--white">
            <i className="icon icon-store is-inline"></i>
            <span>{`Être alerté de l'ouverture de la billetterie`}</span>
          </a>
        );*/
      }
    } else {
      return null;
      /*
      return (
        <a
          role="button"
          tabIndex='0'
          onClick={() => {
            handleTagEvent(
              'billet_match',
              'alerte_billet',
              title,
              userPref
            )();
            localStorage.setItem('alertLocal', `${id}`);
            displayModal('MODAL_UNSUBSCRIBE_NEWSLETTER');
          }}
          className="btn banner__button btn--white">
          <i className="icon icon-store is-inline"></i>
          <span>{`Être alerté de l'ouverture de la billetterie`}</span>
        </a>
      );*/
    }
  };

  _renderContent = () => {
    const {
      match: {
        params: { tab }
      },
      rencontreData: {
        dernieres_rencontres,
        joueurs,
        staffs,
        faits_de_jeu,
        meta: {
          adversaire,
          reception,
          equipe_adverse,
          france_score_mi_temps,
          france_score,
          adversaire_score,
          adversaire_score_mi_temps,
          afficher_stats,
          afficher_composition,
          afficher_faits_de_jeu,
          rencontre_live
        }
      },
      rencontreFetchStatus
    } = this.props;

    if (rencontreFetchStatus === STATUS_LOADING) {
      return <Loading isWhite />;
    }

    if (tab && tab === 'temps-forts') {
      if (afficher_faits_de_jeu) {
        return (
          <Highlights
            faitsDeJeu={faits_de_jeu}
            francePlaysAtHome={reception}
            france_score_mi_temps={france_score_mi_temps}
            france_score={france_score}
            adversaire_score={adversaire_score}
            adversaire_score_mi_temps={adversaire_score_mi_temps}
            rencontre_live={rencontre_live}
          />
        );
      }
      return null;
    }

    return (
      <Fragment>
        {afficher_stats && (
          <div className="row mt-5">
            <div className="col col-lg-8on9">
              <MatchStats
                reception={reception}
                equipeNom={'France'}
                adversaire={adversaire}
                rencontreData={this.props.rencontreData}
              />
            </div>
          </div>
        )}
        {afficher_composition && (
          <div className="row mt-5">
            <TeamComposition joueurs={joueurs} staffs={staffs} faits={faits_de_jeu} isWomen={this.props.match.params.slug.includes('feminin')} />
          </div>
        )}
        {!!equipe_adverse.replace(/\s/g, '') && !!afficher_composition && (
          <div className="row">
            <OpponentTeamComposition equipe={equipe_adverse} withoutDropdown />
          </div>
        )}
        {dernieres_rencontres && dernieres_rencontres.length > 0 && (
          <div className="row mt-5">
            <LastRencontresSection dernieres_rencontres={dernieres_rencontres} equipeNom={'France'} />
          </div>
        )}
      </Fragment>
    );
  };

  clickTagManager = (socialName: string) => {
    const { meta_title, userPref } = this.props;

    return handleTagEvent('partage', meta_title, socialName, userPref);
  };

  render() {
    const {
      id_rencontre,
      status,
      sidebar_content,
      match: {
        params: { typeRugby, slug, competition, rencontre, tab }
      },
      meta_title,
      rencontre_background,
      rencontreData: {
        meta: {
          arbitre,
          spectateurs,
          lieu,
          billetterie,
          journee,
          date_rencontre,
          france_logo,
          adversaire_logo,
          adversaire,
          reception,
          france_score_mi_temps,
          france_score,
          adversaire_score,
          adversaire_score_mi_temps,
          afficher_faits_de_jeu,
          url_video,
          cta_video,
          rencontre_terminee
        }
      },
      userPref
    } = this.props;
    if (status === STATUS_LOADING) {
      return <Loading isBlue backgroundColor={'#013974'} />;
    }

    const subMenus = [
      {
        menu_order: 1,
        object_slug: 'general',
        title: 'Général',
        description: '',
        featured_media: { src: '' },
        texte_cta: '',
        object_id: 0,
        type_name: 'endur'
      },
      {
        menu_order: 3,
        object_slug: 'temps-forts',
        title: 'Temps Forts',
        description: '',
        featured_media: { src: '' },
        texte_cta: '',
        object_id: 0,
        type_name: 'endur'
      }
    ];
    const date = new Date().toJSON().slice(0, 10);
    const competitionName =
      this.props.rencontreData.competition && this.props.rencontreData.competition.name
        ? this.props.rencontreData.competition.name
        : competition.replace(/-/g, ' ');
    const matchTitle = reception ? `France / ${adversaire}` : `${adversaire} / France`;
    const matchName = reception ? `France-${adversaire}` : `${adversaire}-France`;

    return (
      <Fragment>
        <section className="banner banner--match  banner--bigNoAfter banner--wButton">
          <div
            className="banner__thumbnail img-blue-dark"
            style={{
              backgroundImage: `url(` + (rencontre_background ? rencontre_background : `/img/banner/match.jpg`) + `)`
            }}
          />
          <div className="container">
            <Breadcrumb
              elements={[
                { name: 'accueil', to: '/' },
                { name: 'Équipes de France', to: '/equipe-de-france' },
                { name: slug.replace(/-/g, ' '), to: `/equipe-de-france/${typeRugby}/${slug}` },
                { name: 'résultats', to: `/equipe-de-france/${typeRugby}/${slug}/resultats` },
                competitionName
              ]}
              isDark
            />
            <h1 className="ft-center ft-up has-score">{competitionName}</h1>
            <h2 className="ft-center ft-up">
              {journee ? `Journée ${journee} — ` : ''} {date_rencontre && reorderDateFormat(date_rencontre)}
            </h2>
            <BannerScoreboard
              id_rencontre={id_rencontre}
              reception={reception}
              france_logo={france_logo}
              adversaire_logo={adversaire_logo}
              adversaire={adversaire}
              date_rencontre={date_rencontre}
              france_score={france_score}
              adversaire_score={adversaire_score}
              france_score_mi_temps={france_score_mi_temps}
              adversaire_score_mi_temps={adversaire_score_mi_temps}
              rencontre_terminee={rencontre_terminee}
              tab={tab}
            />
            {!rencontre_terminee &&
              date_rencontre &&
              date_rencontre > date &&
              !billetterie &&
              this.renderTicketingAlert()}
            {!rencontre_terminee && date_rencontre && date_rencontre > date && billetterie && (
              <a
                href={billetterie}
                target="_blank"
                rel="noopener noreferrer"
                className="btn banner__button btn--primary"
                onClick={handleTagEvent('billet_match', 'achat_billet', matchName, userPref)}
              >
                <i className="icon icon-ticket is-inline"></i>
                <span>Acheter vos billets</span>
              </a>
            )}
            {(rencontre_terminee || (date_rencontre && date_rencontre <= date)) && url_video && (
              <a
                href={url_video}
                target="_blank"
                rel="noopener noreferrer"
                className="btn banner__button btn--white banner__button--score"
                onClick={handleTagEvent('accès_FFR_TV', 'replay', matchTitle, userPref)}
              >
                <i className="icon icon-camera is-inline"></i>
                <span>{cta_video ? cta_video : 'Accéder au replay sur FFR TV'}</span>
              </a>
            )}
            <hr className="mt-3 mb-3 mt-md-7 mb-md-4 mt-lg-7 has-score" />
            <div className="banner__infos">
              <span className="ft-tertiary ft-up">{lieu}</span>
              <span className="ft-tertiary ft-up">{spectateurs > 0 && spectateurs + ' spectateurs'}</span>
              <span className="ft-tertiary ft-up mb-0">{arbitre && 'Arbitre : ' + arbitre}</span>
            </div>
          </div>
        </section>
        {afficher_faits_de_jeu && (
          <SubMenuHeader
            subMenus={subMenus}
            subMenuPath={`/equipe-de-france/${typeRugby}/${slug}/rencontres/${competition}/${rencontre}`}
            status={STATUS_SUCCESS}
            niveauMenu={7}
            navClass={'box'}
          />
        )}
        <div className="container">
          <div className="row">
            <div className="col col-md-8 col-lg-9 bg-overflow">
              <section>
                <div className="page">
                  {id_rencontre === 94913 && (
                    <div className="col col-lg-8on9 box box--white mb-5" style={{ padding: '1em', display: 'flex' }}>
                      <small
                        className="icon icon-info"
                        style={{ float: 'left', margin: '8px 20px 8px 8px', color: 'red', fontSize: '22px' }}
                      />
                      <p style={{ margin: '8px 0px', fontWeight: 'bold' }}>
                        {// eslint-disable-next-line max-len
                        `Match annulé : World Rugby et le Comité d'organisation Japan Rugby 2019 ont décidé d’annuler la rencontre suite au passage du Typhon "Hagibis".`}
                      </p>
                    </div>
                  )}
                  {this._renderContent()}
                  <hr className="separator mt-6 mb-4" />
                  <div className="row mt-4">
                    <div className="col col-lg-7on9">
                      {meta_title && (
                        <FooterSocial
                          url={window.location.href}
                          title={meta_title}
                          titleclass="mb-3"
                          clickTagManager={socialName => this.clickTagManager(socialName)}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </section>
            </div>
            <Sidebar sidebarContent={sidebar_content} />
          </div>
        </div>
      </Fragment>
    );
  }
}

export default withHelmet(Rencontre)((Helmet, pageProps) => {
  const ogimage = pageProps.featured_media ? pageProps.featured_media.src : false;
  const ogimagetitle = pageProps.featured_media ? pageProps.featured_media.title : false;
  const description = `Statistiques du match, temps forts, compositions d'équipes, dernières rencontres
  entre ces deux équipes… avec la Fédération Française de Rugby.`;
  return (
    <Helmet>
      <title>{pageProps.meta_title}</title>
      <meta name={'description'} content={description} />
      <meta property={'og:url'} content={window.location.href} />
      <meta property={'og:title'} content={pageProps.meta_title} />
      <meta property={'og:description'} content={description} />
      {ogimage && <meta property={'og:image'} content={ogimage} />}
      {ogimage && <meta property={'og:image:url'} content={ogimage} />}
      {ogimage && ogimagetitle && <meta property={'og:image:title'} content={ogimagetitle} />}
      <link rel={'canonical'} href={window.location.href} />
    </Helmet>
  );
});
